// src/components/productPage/singleProductPageComponents/ysim/axis.ts
import type { AxisScale } from './types';
import { LABELS } from './types';

export function getYAxisScaleType(label: string): 'linear' | 'logarithmic' {
    switch (label) {
        case LABELS.TCC:
        case LABELS.VCAC:
        case LABELS.VBIAS:
        case LABELS.RIPPLE:
        case 'S11 Phase (Degrees)':
        case 'S21 Phase (Degrees)':
        case 'S11 Magnitude':
        case 'S21 Magnitude':
            return 'linear';
        case 'Impedance (Ohms)':
        case 'ESR (Ohms)':
        default:
            return 'logarithmic';
    }
}
export function getYAxisTitle(label: string): string {
    switch (label) {
        case LABELS.TCC:
        case LABELS.VCAC:
        case LABELS.VBIAS:
            return 'Cap. Change Rate (%)';
        case LABELS.RIPPLE:
            return 'Temperature (°C)';
        default:
            return label;
    }
}

export function buildYScale(
    label: string,
    position: 'left' | 'right',
    ticks: any,
    datasetMin: number | undefined
): AxisScale {
    return {
        type: getYAxisScaleType(label),
        title: { display: true, text: getYAxisTitle(label) },
        ticks,
        position,
        min: undefined,
        max: undefined,
        suggestedMin: datasetMin !== undefined ? datasetMin / 1.1 : undefined,
    };
}
